module.exports = __webpack_public_path__ + "static/media/SC.74d594ef.png";